
document.addEventListener("DOMContentLoaded", function () {
  const source = document.querySelector(".ma-phone");
  const target = document.querySelector(".ma-phone-swaped");

  if (!source || !target) return;

  // Function to update the swapped button
  const syncPhone = () => {
    const newNumber = source.textContent.trim();
    const newHref = source.getAttribute("href");
    if (newNumber && newHref) {
      target.textContent = newNumber;
      target.setAttribute("href", newHref);
    }
  };

  // Initial sync on load
  syncPhone();

  // Watch for dynamic changes (from tracking scripts)
  const observer = new MutationObserver(() => {
    syncPhone();
  });

  observer.observe(source, {
    childList: true,
    characterData: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["href"]
  });
});
